<template>
    <div>
        <v-container fluid pt-0 grid-list-xl>
            <section-tooltip title="Orderhistory"></section-tooltip>
            <app-card customClasses="mb-30 inherit-overflow">
                <v-tooltip bottom>
                    <v-btn slot="activator" fab dark color="blue" @click="saveFilter" v-if="user.isAdmin" small absolute
                        top right style="right: 125px;">
                        <v-icon dark>save</v-icon>
                    </v-btn>
                    <span>Save filter for user</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <v-btn slot="activator" fab dark color="blue" @click="editFilters" v-if="user.isAdmin" small
                        absolute top right style="right: 70px;">
                        <v-icon dark>edit</v-icon>
                    </v-btn>
                    <span>Edit filter</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <v-btn slot="activator" fab dark color="blue" @click="$refs.ohGrid.instance.exportToExcel(false)"
                        small absolute top right>
                        <v-icon dark>grid_on</v-icon>
                    </v-btn>
                    <span>Excel export</span>
                </v-tooltip>
                <div class="header-container" v-if="currentEventGroup">
                    <img :src="`/static/img/country_icons/${currentEventGroup.countryCode}.png`">
                    <h1>{{ currentEventGroup.name }}</h1>
                </div>
                <div class="filter-container">
                    <v-btn :color="currentSelectedFilter === filter.state ? 'blue darken-4' : 'blue'" outline round
                        v-for="(filter, index) in orderhistoryFilters" @click="loadFilter(filter.state)" :key="index">{{
                            filter.name
                        }}</v-btn>
                </div>
                <sales-info-box :event-group-id="parseInt($route.params.eventgroupId)"
                    v-if="$route.params.eventgroupId"></sales-info-box>
                <div class="grid-container">
                <div class="horizontal-scroll-container">
                    <div class="horizontal-scroll-content"></div>
                </div>
                <dx-data-grid class="gptOrderHistory--grid" ref="ohGrid" :allow-column-reordering="true"
                    :allow-column-resizing="true" :column-auto-width="true" :data-source="dataSource"
                    :filter-builder="filterBuilder" :filter-value="filterValue" :headerFilter="{ visible: true }"
                    :height="'1000px'" :remote-operations="remoteOperations" :responsive="true"
                    :row-alternation-enabled="true" :selection="{ mode: 'single' }" :show-borders="true"
                    :show-column-lines="true" :state-storing="stateStoring" @cell-click="onCellClick"
                    @exported="onExported" @row-prepared="onRowPrepared" @contentReady="onContentReady">
                    
                    <dx-column data-field="id" caption="Booking ID" :allow-filtering="false" :visible="true" />
                    
                    <dx-column data-field="eventBaseName" caption="Event base" :visible="false" />
                    <dx-column data-field="eventGroupName" caption="Event group name" :visible="false" />
                    <dx-column data-field="event_group_id" caption="Event group ID" :allow-filtering="false"
                        :visible="false" />
                    <dx-column data-field="wo_partner_name" caption="Partner" :allow-filtering="true"
                        :visible="false" />
                    <dx-column data-field="wo_date" cell-template="dateTemplate" caption="Date" data-type="date"
                        sort-order="desc" width="120" :allow-filtering="true" :format="'dd/MM/yyyy'" />
                    <dx-column data-field="eventShortName" caption="Event" width="200" :allow-filtering="true" />
                    <dx-column caption="Shop name" cell-template="shopCellTemplate" data-field="ShortName"
                        :visible="true" />
                    <!-- <dx-column
                        caption="Organization"
                        :allow-filtering="false"
                        cell-template="organizationCellTemplate"
                    /> -->
                    <dx-column data-field="customer_name" caption="Customer" />
                    <dx-column data-field="customer_email" caption="Email" />
                    <dx-column data-field="customerInvoice" caption="customerInvoice" data-type="boolean" width="80"
                        :allow-filtering="false" />

                    <dx-column data-field="wo_partner_name" caption="PartnerName" :visible="true" />
                    <dx-column alignment="center" data-type="number" v-for="column in articleTypeColumns" width="60"
                        :allow-filtering="false" :caption="column.caption" :data-field="column.field"
                        :key="column.key" />
                    <dx-column data-field="price" caption="Price" :format="currencyFormat" :allow-filtering="true"
                        cell-template="priceCellTemplate" />
                    <dx-column data-field="cc_currency" caption="Currency" :visible="true" />
                    <dx-column data-field="agency_value" caption="Agency value" data-type="number"
                        :format="currencyFormat" :allow-filtering="false" />
                    <dx-column caption="Invoice ID" data-field="FOHESInvoiceNumber"
                        v-if="user.settings.orderHistoryShowFohesColumns" :allow-filtering="false" />
                    <dx-column caption="Confirmation ID" data-field="FOHESConfirmationNumber"
                        v-if="user.settings.orderHistoryShowFohesColumns" :allow-filtering="false" />
                    <dx-column caption="Tracking ID" data-field="ShippingTrackingNumber"
                        v-if="user.settings.orderHistoryShowTrackingColumns" :allow-filtering="false" />
                    <dx-column caption="Required logo" data-field="RequiredLogo"
                        v-if="user.settings.orderHistoryShowRequiredLogo" :allow-filtering="false" />
                    <dx-column caption="Order Info" :allow-filtering="false" cell-template="orderInfoCellTemplate" />
                    <dx-column data-field="PaymentStatus" caption="Paid" data-type="boolean" width="80"
                        :allow-filtering="false" />
                    <dx-column data-field="PlacedByFohes" caption="Fohes" data-type="boolean" width="80"
                        :allow-filtering="false" />
                    <dx-column data-field="ShippingStatus" caption="Shipped" data-type="boolean" width="90"
                        :allow-filtering="false" />
                    <dx-column data-field="isContractual" caption="Contractual" data-type="number" :visible="true" />
                    <dx-column 
                        data-field="payment_date_deadline" 
                        cell-template="paymentDeadlineTemplate"
                        caption="Payment deadline" 
                        data-type="string" 
                        width="120" 
                        :allow-filtering="true"
                        :format="'dd/MM/yyyy'" 
                    />
                    <dx-column 
                        data-field="payment_date"
                        cell-template="paymentDateTemplate" 
                        caption="Invoice date" 
                        data-type="string" 
                        width="120"
                        :allow-filtering="true" 
                        :format="'dd/MM/yyyy'" 
                    />
                        <div slot="organizationCellTemplate" slot-scope="data">
                        <span v-if="data.data.AgencyName !== null">{{ data.data.AgencyName }}</span>
                        <span v-if="data.data.wo_partner_name !== '' && data.data.AgencyName === null">{{
                            data.data.wo_partner_name
                        }}</span>
                        <span v-if="data.data.wo_partner_name == '' && data.data.AgencyName == null">External</span>
                    </div>
                    <dx-column data-field="wo_status" caption="Status" data-type="number" :visible="true" />
                    <div slot="orderInfoCellTemplate" slot-scope="data">
                        <v-tooltip bottom v-if="data.data.OrderInfoText">
                            <span slot="activator">
                                <v-icon dark>info</v-icon>
                            </span>
                            <span>{{ data.data.OrderInfoText }}</span>
                        </v-tooltip>

                    </div>
                    <div slot="shopCellTemplate" slot-scope="data">
                        <span :title="data.data.shopId">{{ data.data.ShortName }}</span>
                    </div>
                    <div slot="priceCellTemplate" slot-scope="data">
                        <span
                            :class="{ 'contractual-text': data.data.isContractual, 'canceled-text': data.data.wo_status === -2 }">{{
                                data.data.isContractual === 1 ? 0 : data.value | currency
                            }}</span>
                    </div>
                    <div slot="paymentDeadlineTemplate" slot-scope="data">
                        <span :class="{ 'one-week-due': isDue7Days(data.value), 'overdue': isOverdue(data.value) }"> {{
                            formatDate(data.value)
                        }}</span>
                    </div>
                    <div slot="dateTemplate" slot-scope="data">

                        <span :class="{ 'is-new': isNew(data.value) }"> {{
                            formatDate(data.value)
                        }}</span>
                    </div>
                    <div slot="paymentDateTemplate" slot-scope="data">
                        <span :class="{ 'is-new': isNew(data.value) }"> {{
                            formatDate(data.value)
                        }}</span>
                        </div>
                    <dx-export :enabled="false" :file-name="'dashboard'" :visible="false" />
                    <dx-scrolling mode="infinite" />
                    <dx-filter-row :visible="true"></dx-filter-row>
                    <dx-filter-panel :visible="true" />
                    <dx-filter-builder-popup :position="filterBuilderPopupPosition" />
                </dx-data-grid>
                </div>
            </app-card>
        </v-container>
        <detail-view :order="selectedOrder" :isVisible="selectedOrder !== null"
            @close="onOrderDetailsClose"></detail-view>
        <add-filter-view :isVisible="showAddFilterDialog" :filter="currentFilter" @close="onFilterSaveDialogClose"
            @save="onFilterSave" v-if="user.isAdmin"></add-filter-view>
        <edit-filters-view :isVisible="showEditFiltersDialog" @close="onFiltersEditDialogClose"
            v-if="user.isAdmin"></edit-filters-view>
    </div>
</template>

<script>
import CustomStore from 'devextreme/data/custom_store'
import { mapGetters } from 'vuex'

import AddFilterView from './AddFilterView'
import DetailView from './DetailsView'
import EditFiltersView from './EditFiltersView'
import SalesInfoBox from './SalesInfoBox'

import canceledStyles from '../../constants/order-history-canceled-styles'
import shopColors from '../../constants/order-history-shop-colors'
import moment from 'moment'

const rowClasses = [...canceledStyles.map(row => row.value), ...shopColors.map(row => row.value), 'complete']

const shortArticleTypeNames = {
    '1Day': 1,
    '2Days': 2,
    '3Days': 3,
    Parking: 'P',
    Coach: 'C',
    'Parking late': 'PL',
    'Chauffeur late': 'CL',
    'Parking Friday only': 'PF',
    'Parking Friday only late': 'PFL',
    'EQ Apartment 2 Days': '2EQ',
    'Emotion Club 2 Days': '2EC',
    'EQ Apartment': '1EQ',
    'Emotion Club': '1EC',
    'EQ Apartment Internal': '1EQI',
    'Emotion Club Internal': '1ECI',
    'EQ Apartment 2 Days Internal': '2EQI',
    'Emotion Club 2 Days Internal': '2ECI',
    'Parking FOC': 'FOC'
}

/**
EQ Apartment Internal
4:29
Emotion Club Internal
4:29
EQ Apartment 2 Days Internal
4:29
Emotion Club 2 Days Internal */

export default {
    components: {
        DetailView,
        AddFilterView,
        EditFiltersView,
        SalesInfoBox
    },
    data() {
        return {
            text: '',
            filterBuilderPopupPosition: {
                of: window,
                at: 'top',
                my: 'top',
                offset: { y: 10 }
            },
            filterBuilder: {},
            filterValue: null,
            dataSource: null,
            remoteOperations: {
                sorting: true,
                paging: true,
                grouping: true,
                filtering: true
            },
            currencyFormat: {
                type: 'currency',
                precision: 2
            },
            selectedOrder: null,
            showAddFilterDialog: false,
            showEditFiltersDialog: false,
            currentFilter: {},
            currentState: null,
            currentSelectedFilter: null,
            filters: []
        }
    },
    computed: {
        ...mapGetters([
            'articleTypes',
            'season',
            'orders',
            'user',
            'orderhistoryFilters',
            'eventGroupsForCurrentSeason'
        ]),
        articleTypeColumns() {
            const { articleTypes } = this
            const { orderHistoryArticles = [] } = this.user.settings
            return orderHistoryArticles.map(id => ({
                caption: this.getShortArticleTypeName(id),
                field: `salesByType[${id}]`,
                key: id
            }))
        },
        stateStoring() {
            const self = this
            return {
                enabled: true,
                savingTimeout: 100,
                type: 'custom',
                customSave: state => {
                    self.setFilterState(state)
                }
            }
        },
        widgetLayout() {
            return this.dashboard.widgets.map(widget => widget.layout)
        },
        currentEventGroup() {
            if (this.$route.params.eventgroupId) {
                return this.eventGroupsForCurrentSeason.find(ev => ev.id === parseInt(this.$route.params.eventgroupId))
            }
            return null
        }
    },
    watch: {
        season: function () {
            this.$refs.ohGrid.instance.refresh()
        },
        orderhistoryFilters(vals) {
            vals.map(filter => {
                if (filter.name.toLowerCase() === 'default') {
                    console.log(filter)
                    this.loadFilter(filter.state)
                }
            })
            console.log(vals)
        }
    },
    methods: {
        saveFilter() {
            this.showAddFilterDialog = true
            this.currentFilter = {
                name: 'New Filter',
                user: [],
                state: this.currentState
            }
        },
        editFilters() {
            this.showEditFiltersDialog = true
        },
        getShortArticleTypeName(id) {
            const articleType = this.articleTypes.find(type => type.id === id)
            if (!articleType || !('Name' in articleType)) {
                return '?'
            }
            return articleType.Name in shortArticleTypeNames
                ? shortArticleTypeNames[articleType.Name]
                : articleType.Name.substr(0, 2).toUpperCase()
        },
        loadFilter(filter) {
            this.currentSelectedFilter = filter
            this.$refs.ohGrid.instance.state(filter)
        },
        onRowPrepared(e) {
            if (!e.data) return
            const { orderHistoryCanceledStyle = 'canceled', orderHistoryShopColors = [] } = this.user.settings
            const { PaymentStatus, PlacedByFohes, ShippingStatus, shopId, wo_status } = e.data
            const { classList } = e.rowElement
            classList.remove(...rowClasses)
            classList.add('gptOrderHistory--row')

            const shopColor = orderHistoryShopColors.find(row => row.shopId == shopId)

            if (shopColor) {
                classList.add(shopColor.color)
            }

            if (PaymentStatus && PlacedByFohes && ShippingStatus) {
                classList.add('complete')
            }

            if (e.rowType == 'data' && wo_status === -2) {
                classList.add(orderHistoryCanceledStyle)
            }
        },
        onCellClick(e) {
            this.selectedOrder = e.data
        },
        onOrderDetailsClose() {
            this.selectedOrder = null
        },
        onFilterSaveDialogClose() {
            this.reloadFilters()
            this.showAddFilterDialog = false
        },
        onFiltersEditDialogClose() {
            this.showEditFiltersDialog = false
        },
        onFilterSave(filter) {
            this.filters.push(filter)
            this.showAddFilterDialog = false
            this.$store.dispatch('insertOrderhistoryFilter', filter).then(() => {
                this.reloadFilters()
            })
        },
        setFilterState(state) {
            this.currentState = state
        },
        onExported() { },

        onContentReady(e) {
            const scrollContainer = document.querySelector('.horizontal-scroll-container');
            const gridContent = e.component.getScrollable().$content();
            
            if (scrollContainer && gridContent) {
                // Verzögerung für korrekte Breitenberechnung
                setTimeout(() => {
                    const width = gridContent.get(0).scrollWidth;
                    scrollContainer.querySelector('.horizontal-scroll-content').style.width = width + 'px';
                    
                    // Force scrollbar visibility by adding minimal padding
                    if (width > scrollContainer.clientWidth) {
                        scrollContainer.style.paddingBottom = '1px';
                    }
                }, 100);
                
                const gridScrollable = e.component.getScrollable();
                
                scrollContainer.addEventListener('scroll', () => {
                    gridScrollable.scrollTo({ left: scrollContainer.scrollLeft });
                });
                
                gridScrollable.on('scroll', (e) => {
                    scrollContainer.scrollLeft = e.scrollOffset.left;
                });
            }
        },
        reloadFilters() {
            this.$store.dispatch('getOrderhistoryFiltersForUser')
            if (this.user.isAdmin) {
                this.$store.dispatch('getAdminOrderhistoryFilters')
            }
        },
        isDue7Days: function (value) {
            if (!value)
                return false;
            else
                return moment().isAfter(moment(value).subtract(7, 'd'));
        },
        isOverdue: function (value) {
            if (!value)
                return false;
            else
                return moment().isAfter(moment(value));
        },
        isNew: function (value) {
            if (!value)
                return false;
            else
                return moment().isBefore(moment(value).add(3, 'd'));
        },
        formatDate: function (value) {
            if (value)
                return moment(value).format('DD/MM/YYYY');
            else
                return ''
        }
    },
    mounted() {
        this.reloadFilters()
         // Add horizontal scroll sync
        const scrollContainer = document.querySelector('.horizontal-scroll-container');
        const gridContainer = document.querySelector('.dx-datagrid-content');
        
        if (scrollContainer && gridContainer) {
            scrollContainer.querySelector('.horizontal-scroll-content').style.width = gridContainer.scrollWidth + 'px';
            
            scrollContainer.addEventListener('scroll', () => {
                gridContainer.scrollLeft = scrollContainer.scrollLeft;
            });
            
            gridContainer.addEventListener('scroll', () => {
                scrollContainer.scrollLeft = gridContainer.scrollLeft;
            });
        }
    },
    created() {
        const self = this

        this.dataSource = {
            store: new CustomStore({
                load: function (loadOptions) {
                    const params = {
                        skip: loadOptions.skip,
                        take: loadOptions.take,
                        group: loadOptions.group,
                        filter: loadOptions.filter,
                        sort: loadOptions.sort,
                        query: { FK_Season: self.season }
                    }

                    if (self.$route.params.eventgroupId) {
                        const eventgroupId = parseInt(self.$route.params.eventgroupId)
                        if (Array.isArray(params.filter)) {
                            if (Array.isArray(params.filter[0])) {
                                params.filter.push('and')
                                params.filter.push(['event_group_id', '=', eventgroupId])
                            } else {
                                const tempFilter = params.filter
                                params.filter = [tempFilter, 'and', ['event_group_id', '=', eventgroupId]]
                            }
                        } else {
                            params.filter = ['event_group_id', '=', eventgroupId]
                        }
                    }
                    
                    return self.$store.dispatch('getOrders', params)
                }
            })
        }
    }
}
</script>
<style lang="scss">
.one-week-due {
    font-weight: bold;
    color: #c7c72d;
}

.overdue {
    font-weight: bold;
    color: red;
}
.is-new {
    font-weight: bold;
}
.grid-container {
    position: relative;
    height: 1000px;
}

.horizontal-scroll-container {
    overflow-x: scroll;
    margin-bottom: 10px;
    height: 16px;
    background: #f0f0f0;
    -webkit-appearance: none;
    /* Verhindert das Auto-Ausblenden in Chrome */
    &::-webkit-scrollbar {
        -webkit-appearance: none;
        height: 16px;
    }
    
    &::-webkit-scrollbar-thumb {
        background-color: #c1c1c1;
        border: 2px solid #f0f0f0;
        border-radius: 8px;
        min-width: 30px;
        
        /* Immer sichtbar machen */
        &:vertical,
        &:horizontal {
            display: block;
        }
    }
    
    &::-webkit-scrollbar-track {
        background-color: #f0f0f0;
    }
    
    /* Firefox Styles */
    scrollbar-width: thin;
    scrollbar-color: #c1c1c1 #f0f0f0;
}

.horizontal-scroll-container::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
    border-radius: 8px;
    border: 2px solid #f0f0f0;
}

.horizontal-scroll-container::-webkit-scrollbar-track {
    background: #f0f0f0;
}

.horizontal-scroll-content {
    height: 1px;
}

.gptOrderHistory--grid {
    height: calc(100% - 20px) !important;
}
</style>

